import { Component } from '@angular/core';
import { DocumentListLoadingService } from 'app/services/document-list-loading.service';

@Component({
    selector: 'app-document-list-progress',
    templateUrl: './document-list-progress.component.html',
    styleUrls: ['./document-list-progress.component.scss'],
})
export class DocumentListProgressComponent {
    loading$ = this.loadingService.loading$;

    constructor(private loadingService: DocumentListLoadingService) {}
}
